import styles from '../index.module.less';

export default function LoginLogo({
  onClick,
  style,
  src = '/images/logo.svg',
}: {
  onClick: () => void;
  style?: React.CSSProperties;
  src?: string;
}) {
  return (
    <div className={styles.logo} onClick={onClick} style={style}>
      <img
        src={src || '/images/logo.svg'}
        alt="logo"
        onError={(event) => {
          event.currentTarget.src = '/images/logo.svg';
        }}
      />
    </div>
  );
}
